import React, { useState, useRef } from "react";
import "./style/shippingManifest.css";
import PageTitle from "../Common/PageTitle/PageTitle";
import { Container, Row, Col, Form, Button, Table } from "react-bootstrap";

const filterOptions = [
  {
    value: "2101 Larimer St, Denver",
    label: "Denver Care Hub @ 2101 Larimer St, Denver"
  },
  {
    value: "8 E Charleston Blvd, Las Vegas",
    label: "Las Vegas Care Hub @ 8 E Charleston Blvd"
  }
];
const tableColumns = [
  {
    label: "Id",
    key: "id"
  },
  {
    label: "Created Date",
    key: "createdDate"
  },
  {
    label: "Shipping Date",
    key: "shippingDate"
  },
  {
    label: "Shipping Provider",
    key: "shippingProvider"
  },
  {
    label: "Tracking Number",
    key: "trackingNumber"
  }
];
const dummyData = [
  {
    id: 1,
    createdDate: "2021-08-01",
    shippingDate: "2021-08-02",
    shippingProvider: "UPS",
    trackingNumber: "123456"
  },
  {
    id: 2,
    createdDate: "2021-08-02",
    shippingDate: "2021-08-03",
    shippingProvider: "FedEx",
    trackingNumber: "654321"
  },
  {
    id: 3,
    createdDate: "2021-08-03",
    shippingDate: "2021-08-04",
    shippingProvider: "USPS",
    trackingNumber: "456123"
  }
];

function ShippingManifest() {
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [tableData, setTableData] = useState(dummyData);

  const handleFilterChange = e => {
    const { name, value } = e.target;
    if (name === "fromDate") {
      setFormDate(value);
    } else if (name === "toDate") {
      setToDate(value);
    } else if (name === "location") {
      setSelectedLocation(value);
    }
  };

  return (
    <Container fluid>
      <Col>
        <PageTitle titleName="Shipping Manifest" />
      </Col>

      <Row className="filter-row">  
        <Col md={3}>
          <Form.Group>
            <Form.Label>From Date:</Form.Label>
            <Form.Control type="date" name="formDate" value={formDate} onChange={handleFilterChange} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>To Date:</Form.Label>
            <Form.Control type="date" name="toDate" value={toDate} onChange={handleFilterChange} />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Location:</Form.Label>
            <Form.Control as="select" name="location" value={selectedLocation} onChange={handleFilterChange}>
              <option value="">Select Location</option>
              {/* Add options for locations */}
              {filterOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Button variant="primary">Apply Filters</Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <Table responsive>
            <thead>
              <tr>
                {tableColumns.map((column, index) => (
                  <th key={index}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  {tableColumns.map((column, index) => (
                    <td key={index}>{row[column.key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}

export default ShippingManifest;
